import { WorkScheduleConstant } from '../actions/constants/WorkScheduleConstant';

const initialState = {
	isLoading: false,
	effectiveBase: null,
	userBase: null,
	companyBase: null,
	companyTimezone: null,
	overrides: [],
	currentYearMonth: null,
	error: null,
	saveSuccess: false,
};

export const WorkScheduleReducer = (state = initialState, action) => {
	switch (action.type) {
		case WorkScheduleConstant.GET_MY_SUCCESS:
			return {
				...state,
				effectiveBase: action.payload.effectiveBase || null,
				userBase: action.payload.userBase || null,
				companyBase: action.payload.companyBase || null,
				companyTimezone: action.payload.companyTimezone || null,
				overrides: action.payload.overrides || [],
				error: null,
			};
		case WorkScheduleConstant.GET_MY_FAIL:
			return { ...state, error: 'Failed to load work schedule' };
		case WorkScheduleConstant.SET_YEAR_MONTH:
			return { ...state, currentYearMonth: action.payload };
		case WorkScheduleConstant.SAVE_BASE_SUCCESS:
		case WorkScheduleConstant.RESET_BASE_SUCCESS:
		case WorkScheduleConstant.ADD_OVERRIDE_RANGE_SUCCESS:
			return { ...state, saveSuccess: true };
		case WorkScheduleConstant.LOADING:
			return { ...state, isLoading: true, saveSuccess: false };
		case WorkScheduleConstant.LOADED:
			return { ...state, isLoading: false };
		default:
			return state;
	}
};
